import Result from './Result';

export default class extends Result {
  constructor(type, avatar, name, tag, id) {
    super(type, avatar, name);
    this.tag = `@${tag}`;
    this.to = { name: 'Profile', params: { id } };
  }
}
